<template>
  <div>
    <div v-show="loading">
      <v-skeleton-loader v-for="item in 5" :key="item" class="mx-auto" type="list-item-avatar" />
    </div>
    <ViewableCourseTree
      v-if="activeCourseEditTree.course && activeCourseEditTree.course.children"
      :items="activeCourseEditTree.course.children"
      :course-id="activeCourseEditTree.course.id"
      :parent-id="null"
    />
  </div>
</template>

<script>
import { trainingsMode } from '@/shared/enums';
import ViewableCourseTree from '@/components/manage/courses/ViewableCourseTree.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('courses');

export default {
  components: {
    ViewableCourseTree
  },
  computed: mapState({
    activeCourseEditTree: 'activeCourseEditTree',
    loading: state => state.activeCourseEditTree.loading
  }),
  async mounted() {
    this.switchActiveMode({ mode: trainingsMode.ViewCourse });
    const result = this.requestModuleEdit({ id: Number(this.$route.params.id) });
    if (!result) {
      await this.$router.push('/');
    }
  },
  destroyed() {
    this.requestModuleEditClear();
  },
  methods: mapActions(['switchActiveMode', 'requestModuleEdit', 'requestModuleEditClear'])
};
</script>
